import * as React from 'react';
import { useEntityDetailsProps } from '@web-config-app/entity-form';
import { EntityDataTableModal } from '@web-config-app/core-react-ui';
import { isUsingConfigAppBackend } from '@web-config-app/common';

export const EntityDataTableModalContainer = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    entityRootData,
    otherAuthoringEnvironmentState,
    currentAuthoringEnvironment,
    name,
    entity,
    nodeMap: entityTreeNodeMap,
  } = useEntityDetailsProps();
  const {
    entityData: entityRootDataOnOtherEnvironment,
    environmentKey: otherEnvironmentKey,
    isTargetSelected = true,
  } = otherAuthoringEnvironmentState ?? {};
  // `environmentKey` names a provisional target while the author hasn't picked one (a tenant
  // with several promotion targets), and the detailed fetch is switched off until they do.
  // Showing that column anyway would render an empty "Test 4" next to the current
  // environment, which reads as "this entity doesn't exist there" rather than "not loaded".
  const otherEnvironmentData =
    isTargetSelected && otherEnvironmentKey
      ? {
          key: otherEnvironmentKey,
          data: entityRootDataOnOtherEnvironment,
        }
      : undefined;
  const isUsingConfigAppBE = isUsingConfigAppBackend({
    entityLevelOverride: entity?.isUsingConfigAppBackend,
  });

  return (
    <EntityDataTableModal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      entityTreeNodeMap={entityTreeNodeMap}
      currentEnvironmentData={{
        key: currentAuthoringEnvironment,
        data: entityRootData,
      }}
      dataPath={
        isUsingConfigAppBE ? 'attributes.domainEntityAttributes' : 'attributes'
      }
      otherEnvironmentData={otherEnvironmentData}
      entityName={name}
    />
  );
};
